import { type AWSWebCore, WebCoreFactory } from '@lemoncloud/lemon-web-core';

import { AWS_REGION, PROJECT } from '@muzly/shared';

import { getApiEndpoint, isApiEnabled } from './config';

let transport: AWSWebCore | null = null;

/**
 * Lazy lemon-web-core singleton. Never constructed while the endpoint is empty —
 * callers gate on `isApiEnabled()` first.
 */
export const getWebTransport = (): AWSWebCore => {
  if (!isApiEnabled()) {
    throw new Error('muzly API is disabled: API_ENDPOINT is empty');
  }
  transport ??= WebCoreFactory.create({
    cloud: 'aws',
    // lemon-web-core namespaces its localStorage keys by project.
    project: (PROJECT || 'muzly').toLowerCase(),
    oAuthEndpoint: getApiEndpoint(),
    region: AWS_REGION,
    storage: localStorage,
  });
  return transport;
};
